import script from "./course.vue?vue&type=script&setup=true&lang=js"
export * from "./course.vue?vue&type=script&setup=true&lang=js"

import "./course.vue?vue&type=style&index=0&id=356066b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356066b0"]])

export default __exports__